import '@/global.css'
import { Input } from "@/components/ui/input"
import { useState } from 'react'
import { Link } from 'react-router'
import { ROUTE } from '@/routes/constants'
import { requestCaptcha, sendResetPassword } from '@/services/generatedAPIs'
import { generateVerificationToken } from '@/lib/crypto'
import { toast } from 'sonner'
import { TFunction } from 'i18next'
import { useTranslation } from 'react-i18next';
import { EmailIcon } from './login-icons'

// 移动端「申請重設密碼」表单：流式布局，沿用 Figma 配色（蓝色按钮 + 灰色 input）。

async function onAction(formData: FormData, t: TFunction): Promise<void> {
  const email = formData.get("email");
  if (!email || typeof email !== "string") return;
  try {
    const rsp1 = await requestCaptcha({ nonce: email });
    if (rsp1.code === 200 && !rsp1.data) {
      const rsp2 = await sendResetPassword({ t: generateVerificationToken(email) });
      if (rsp2.code === 200) toast(t('component.sendsuccess'));
      else toast(rsp2.message);
    } else {
      toast(rsp1.message);
    }
  } catch {
    toast(t('component.networkError') ?? 'Network error, please try again.');
  }
}

function MobileRequestResetPasswordForm() {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  return (
    <form
      action={async (fd: FormData) => { setIsLoading(true); await onAction(fd, t); setIsLoading(false); }}
      style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: 16 }}
    >
      <h2 style={{ margin: 0, textAlign: 'center', fontSize: 24, fontWeight: 600, color: '#000' }}>{t('user.reset-password-title')}</h2>
      <p style={{ margin: 0, textAlign: 'center', fontSize: 13, color: '#575C60', lineHeight: '20px' }}>
        {t('user.reset-password-subtitle')}
      </p>

      <div>
        <label htmlFor="email" style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#575C60', marginBottom: 6 }}>
          {t('user.email')}
        </label>
        <div style={{ position: 'relative', height: 48 }}>
          <EmailIcon aria-hidden="true" style={{ position: 'absolute', left: 18, top: 13, width: 22, height: 22, color: '#575C60', zIndex: 1 }} />
          <Input
            id="email" name="email" type="email" required placeholder="scholar@atelier.edu.hk"
            onInvalid={(e: any) => { e.target.setCustomValidity(t("user.email-error")); }}
            onInput={(e: any) => { e.target.setCustomValidity(""); }}
            className="pl-12 pr-4 placeholder:text-[rgba(115,119,123,0.5)]"
            style={{ width: '100%', height: 48, borderRadius: 24, background: '#F3F3F4', border: 0, fontSize: 14, color: '#1F1F1F' }}
          />
        </div>
      </div>

      <button
        type="submit"
        disabled={isLoading}
        style={{
          marginTop: 4, width: '100%', height: 52, borderRadius: 26,
          background: '#5BC9E8', color: '#FFFFFF', border: 0,
          fontSize: 18, fontWeight: 500, cursor: 'pointer', opacity: isLoading ? 0.6 : 1,
        }}
        className="hover:brightness-[0.97]"
      >
        {isLoading ? '...' : t('user.send-reset-password')}
      </button>

      <div style={{ textAlign: 'center', fontSize: 14, marginTop: 4 }}>
        <Link to={ROUTE.LOGIN} style={{ color: '#5BC9E8' }} className="underline underline-offset-4">{t('user.sign-in')}</Link>
      </div>
    </form>
  );
}

export default MobileRequestResetPasswordForm;
